import 'devextreme/dist/css/dx.common.css'
import 'devextreme/dist/css/dx.light.css'
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'es6-promise/auto'
import 'babel-polyfill'
import 'expose-loader?$!expose-loader?jQuery!jquery'
import Vue from 'vue'
import vueHeadful from 'vue-headful'
import _ from 'lodash'
import VModal from 'vue-js-modal'
import VeeValidator, { Validator } from 'vee-validate'
import VeeValidatorKo from 'vee-validate/dist/locale/ko'
import Storage from 'vue-web-storage'
import App from '@/App'
import router from '@/router'
import store from '@/stores'
import AppConfig from '@/config'
import HttpModule from '@/modules/http'
import AlertModule from '@/modules/alert'
import 'jquery-mousewheel'
import '@/assets/css/reset.css'
import '@/assets/css/layout.css'
import '@/assets/css/content.css'
import '@/assets/css/grid.css'
import '@/assets/css/XEicon/xeicon.min.css'
import '@/assets/css/talkDepositTerms.css'
import '@/assets/css/donation_common.css'
import '@/assets/css/jquery.mCustomScrollbar.css';
import '@/assets/css/style.min.css';
// import '@/assets/js/jquery-1.12.4.min'
import '@/assets/js/common'
import '@/assets/js/jquery-1.12.4.min'
import '@/assets/js/jquery.mCustomScrollbar.min';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import Fragment from 'vue-frag'

Vue.config.productionTip = false

/* vue-headful */
Vue.component('vue-headful', vueHeadful)

/* dialog */
Vue.use(VModal, { dynamic: true })

/* vee validator */
Validator.localize('ko', VeeValidatorKo)

Validator.extend('pwd', {
  getMessage: field => field + ' 항목은 영문 대문자,소문자,숫자,특수기호를 모두 포함한 8자이상이어야합니다.',
  validate: value => {
    return /^.*(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*#?&]).*$/.test(value)
  }
})

Validator.extend('clphNum', {
  getMessage: field => field + ' 항목의 형식이 다릅니다. ex) 010-1111-2222',
  validate: value => {
    return /^\d{3}-\d{3,4}-\d{4}$/.test(value)
  }
})

Validator.extend('telNum', {
  getMessage: field => field + ' 항목의 형식이 다릅니다. ex) 010-1111-2222  또는 02-345-1234',
  validate: value => {
    return /^\d{2,3}-\d{3,4}-\d{4}$/.test(value)
  }
})

Validator.extend('faxnumber', {
  getMessage: field => field + ' 항목의 형식이 다릅니다. ex) 02-1111-2222, 010-1111-2222',
  validate: value => {
    return /^\d{2,3}-\d{3,4}-\d{4}$/.test(value)
  }
})

Vue.use(VeeValidator)

/* swiper */
Vue.use(VueAwesomeSwiper /* { default global options } */)

/* vue-frag */
Vue.directive('frag', Fragment)

/* Http Configuration */
// AppConfig.HTTP_CONFIG.baseURL = process.env.SERVER_BASE_URL
Vue.use(HttpModule, AppConfig)

/* modal alert */
Vue.use(AlertModule)

/* vuex */
window.$store = store

/* storage */
Vue.use(Storage, {
  prefix: 'app_mintit_',
  drivers: ['session', 'local']
})

/* router */
router.beforeEach(async (to, from, next) => {
  const fullModals = store.getters['ModalStore/getModalObjs']

  if (fullModals && fullModals.length > 0) {
    store.commit('ModalStore/hideModal', fullModals.length - 1)
    next(false)
  } else {
    if (to.meta.authRequired) {
      // 권한 체크
      if (to.path != '/home') {
        await store.dispatch('Login/checkAuth', { path: to.path })
          .then((result) => {
            if (result) {
            } else {
              next('/home') // home으로 이동
            }
          })
      }

      // 로그인 체크
      await store.dispatch('Login/isLogin')
        .then((result) => {
          if (result) {
            // navigation 처리
            store.dispatch('TopMenu/navigation', { path: to.path })

            // 최근 메뉴 등록
            store.dispatch('LatestMenu/insertLatestMenu', { name: to.name, desc: to.meta.desc })

            // 화면 버튼 조회
            store.dispatch('Login/btnAuth', { path: to.path })
            return next() // 페이지 이동
          } else {
            return next('/') // 로그인 화면 이동
          }
        })

      // 화면 접근 로그 등록
      //    Vue.httpClient.post('/common/page/log', { comment : to.meta.desc })
    }
    next()
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  methods: {
    hashChangeHandler: function () {
      var target = window.location.hash
      this.$router.push(target.substring(1, target.length))
    }
  },
  mounted: function () {
    // fix for IE 11
    if (!!window.MSInputMethodContext && !!document.documentMode) {
      window.addEventListener('hashchange', this.hashChangeHandler)
    }
  },
  destroyed: function () {
    // fix for IE 11
    if (!!window.MSInputMethodContext && !!document.documentMode) {
      window.removeEventListener('hashchange', this.hashChangeHandler)
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js